// India Standard Time helpers. The store works on IST (UTC+5:30, no daylight saving),
// so admin date filters use IST calendar days, whatever time zone the computer is set to.
export const IST_TZ = 'Asia/Kolkata';
const IST_OFFSET_MS = 330 * 60 * 1000;
const DAY_MS = 24 * 60 * 60 * 1000;

// "YYYY-MM-DD" of the given moment in IST
export function istDay(d = new Date()) {
  return new Date(new Date(d).getTime() + IST_OFFSET_MS).toISOString().slice(0, 10);
}

// Epoch milliseconds of 00:00 IST on a "YYYY-MM-DD" day
export function istDayStart(day) {
  return Date.parse(`${day}T00:00:00Z`) - IST_OFFSET_MS;
}

// "YYYY-MM-DD" that is n days after (negative n: before) the given day
export function addDays(day, n) {
  return new Date(Date.parse(`${day}T00:00:00Z`) + n * DAY_MS).toISOString().slice(0, 10);
}
